import { ResourceBundle } from '@mmw/services-core-resource/types';
import { useSelector } from 'react-redux';

import { resourceBundleSelector } from '../stateSelector';

const useResourceBundle = (): ResourceBundle =>
  useSelector(resourceBundleSelector);

export default useResourceBundle;
